export interface NoteMention {
  _user?: string;
  kind?: 'user' | 'everyone';
  name: string;
  start: number;
  end: number;
}
export interface NoteDraft {
  text: string;
  mentions: NoteMention[];
  requestId: string;
  expectedRevision?: number;
}
export interface MentionUser {
  _id: string;
  name: string;
  email: string;
}
export const newNoteRequestId = () => crypto.randomUUID();
